import { render, staticRenderFns } from "./TechnicalSetupSlide.vue?vue&type=template&id=0c4dfec2&scoped=true"
import script from "./TechnicalSetupSlide.vue?vue&type=script&lang=js"
export * from "./TechnicalSetupSlide.vue?vue&type=script&lang=js"
import style0 from "./TechnicalSetupSlide.vue?vue&type=style&index=0&id=0c4dfec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4dfec2",
  null
  
)

export default component.exports